import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { HeaderConfiguration } from 'src/app/shared/components/header/header.component';
import { JsonConfiguration } from './json';
import { selectSelectedObject } from 'src/app/state/objects/objects.selectors';
import { IStepperData } from 'src/app/shared/components/steppers/vertical-stepper/vertical-stepper.component';

import { first } from 'rxjs/operators';
import {
  ObjetosService,
  queryObjectsCotization,
} from 'src/app/core/http/apiProducto/objetos.service';
import { IStatus } from 'src/app/shared/components/product-price-form/product-price-form.component';
import { IDropDownCoverage } from 'src/app/shared/components/coverages-drop-downs/coverages-drop-downs.component';
import { IContractItem } from 'src/app/state/contracts/contracts.models';
import { selectContract } from 'src/app/state/contracts/contracts.selectors';
import { IPolicyOrQuotation } from 'src/app/core/interfaces/shared/components/IPolicyOrQuotation';
@Component({
  selector: 'app-client-contract',
  templateUrl: './client-contract.component.html',
  styleUrls: ['./client-contract.component.scss'],
  providers: [JsonConfiguration],
})
export class ClientContractComponent implements OnInit {

  stepperData: IStepperData = {
    productData: {
      marca: '',
      modelo: '',
      numSerie: ''
    },
    productReadOnly: false,
    clientData: {
      nombre: '',
      apellidos: '',
      dni: '',
      telefono: '',
      email: '',
      direccion: '',
      codigoPostal: '',
    },
    clientReadOnly: false,
    notificationCardReadOnly: false,
    invoiceData: {
      factura: '',
    },
    invoiceReadOnly: false,
    finishButton: false,
  };

  statusPolicy: IStatus = {
    showInfo: false,
    text: 'En espera',
    backgroundColorClass: 'yellow'
  }

  coveragesContract: IDropDownCoverage[] = []
  anualPrice: number;

  headerConfiguration: HeaderConfiguration =
    this.jsonConfiguration.headerConfiguration;

  selectContract: Observable<IContractItem>;

  queryObjects: queryObjectsCotization;
  objectSelected: any = {};

  stepperIsLinear: boolean = true

  constructor(
    private jsonConfiguration: JsonConfiguration,
    private store: Store,
    private cdRef: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.getContract();
    this.getObjectSelected();
  }

  getObjectSelected() {
    this.store
      .select(selectSelectedObject)
      .pipe(first())
      .subscribe((res) => {
        if (res) {
          this.objectSelected = {
            icon: res.icono,
            name: res.descripcion,
            price: res.selectedProductPrice,
          };
        }
      });
  }

  getContract() {
    let clientInfo: { price?: number; data?: IPolicyOrQuotation };
    this.store
      .select(selectContract)
      .pipe(first())
      .subscribe((res) => {
        if (res) {

          if (res.clientData.policy) {

            clientInfo = res.clientData.policy;
            this.queryObjects = { idPoliza: clientInfo.data.idPoliza };
            this.statusPolicy = { showInfo: true, text: 'Aprobados', backgroundColorClass: 'blue' }
            this.stepperData.productReadOnly = true
            this.stepperData.notificationCardReadOnly = true
            this.stepperData.clientReadOnly = true
            this.stepperData.invoiceReadOnly = true
            this.stepperData.finishButton = false
            this.anualPrice = res.clientData.policy.price
            this.stepperData.idCotizacion = res.clientData.policy.data.idCotizacion
            
            this.coveragesContract = res.coveragesData
            this.stepperData.idCotizacion = res.clientData.policy.data.idCotizacion

          } else {

            clientInfo = res.clientData.quotation
            this.queryObjects = { idCotizacion: clientInfo.data.idCotizacion };

            if (clientInfo.data.estadoInterno == 'Proyecto' && clientInfo.data.autorizada === true) {
              this.statusPolicy = {
                showInfo: true,
                text: 'Pendiente',
                backgroundColorClass: 'red'
              }

              this.stepperData.productReadOnly = true
              this.stepperData.clientReadOnly = true
              this.stepperData.clientReadOnly = true
              this.stepperData.notificationCardReadOnly = true
              this.stepperData.invoiceReadOnly = false
              this.stepperData.finishButton = true
              this.anualPrice = res.clientData.quotation.price

              this.coveragesContract = res.coveragesData
              this.stepperData.idCotizacion = res.clientData.quotation.data.idCotizacion
              
              this.stepperData.showBannerInvoice = true;

            } else if (clientInfo.data.estadoInterno == 'Proyecto' && clientInfo.data.autorizada !== true) {

              this.statusPolicy = {
                showInfo: true,
                text: 'En espera',
                backgroundColorClass: 'yellow'
              }

              this.stepperData.productReadOnly = true
              this.stepperData.clientReadOnly = true
              this.stepperData.notificationCardReadOnly = false
              this.stepperData.invoiceReadOnly = false
              this.anualPrice = res.clientData.quotation.price

              this.stepperData.showBannerNotification = true

              this.coveragesContract = res.coveragesData
              this.stepperData.idCotizacion = res.clientData.quotation.data.idCotizacion
              this.stepperData.sendNotification = true
            }
          }

          this.stepperData.clientData.nombre = clientInfo.data.nombre;
          this.stepperData.clientData.apellidos = [clientInfo.data.apellido1, clientInfo.data.apellido2].filter(x => !!x).join(" "),
          this.stepperData.clientData.dni = clientInfo.data.numDocumento;
          this.stepperData.clientData.telefono = clientInfo.data.numTelefono;
          this.stepperData.clientData.email = clientInfo.data.email;
          this.stepperData.clientData.direccion = clientInfo.data.nombreVia;
          this.stepperData.clientData.codigoPostal = clientInfo.data.codigoPostal;
          this.stepperData.clientData.idPersona = clientInfo.data.idPersona;
          this.stepperData.clientData.idCliente = clientInfo.data.idCliente;
          this.stepperData.productData.marca = res.objectData.objetoMarcaDescripcion;
          this.stepperData.productData.modelo = res.objectData.objetoModeloDescripcion;
          this.stepperData.productData.numSerie = res.objectData.objetoReferencia;
          this.stepperData.invoiceData.factura = res.objectData.objetoFacturaNumero;
          this.stepperIsLinear = false;
        }
      });
  }
}
